var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 25,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#email_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A3887",
  fillRule: "evenodd",
  d: "m30.985 24.152-9.417-11.364-3.736 2.628a2.345 2.345 0 0 1-2.687 0l-3.725-2.628-9.334 11.4a3.5 3.5 0 0 0 1.45.312h25.928c.53 0 1.05-.12 1.52-.348M9.488 11.42 0 4.724V20.9c0 .576.13 1.128.377 1.632zM33 4.724l-9.476 6.684 9.134 11.04A3.7 3.7 0 0 0 33 20.9zM.542 2.192 16.5 13.448 32.458 2.192A3.521 3.521 0 0 0 29.464.5H3.536a3.5 3.5 0 0 0-2.499 1.056 3.7 3.7 0 0 0-.495.636",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "email_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h33v24H0z"
})))));
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "d9a51a35483a26fecc6bbabbe1784331.svg";